import * as Request from '../../request'
import * as Constants from './constants'

export const validateToken = (communityIdentifier: string) =>
  Request.requestActionCreator(Constants.VALIDATE_TOKEN)({
    method: 'GET',
    url: `/auth/validate/${communityIdentifier}`,
  })



// WEBPACK FOOTER //
// ./src/pages/auth/actions.ts